import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <Link to="/" className="inline-flex items-center gap-2 text-white mb-6">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-fire-line text-2xl text-primary-400"></i>
                </div>
                <span className="text-2xl font-bold font-heading whitespace-nowrap">91黑料吃瓜</span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed mt-6 max-w-xs">
                全方位的网络黑料吃瓜平台。每日在线更新独家爆料与热门吃瓜事件，覆盖网络红人、主播博主塌房现场，是您追踪内幕的首选平台。
              </p>
              <div className="flex items-center gap-4 mt-8">
                {['ri-weibo-line', 'ri-wechat-line', 'ri-tiktok-line', 'ri-bilibili-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-white hover:border-foreground-400 transition-colors cursor-pointer"
                    aria-label="社交平台"
                    rel="nofollow"
                  >
                    <i className={`${icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-6">
                联系方式
              </h4>
              <div className="space-y-5">
                <div>
                  <p className="text-foreground-400 text-xs mb-1">地址</p>
                  <p className="text-sm text-foreground-200">北京市朝阳区传媒产业园A座</p>
                </div>
                <div>
                  <p className="text-foreground-400 text-xs mb-1">电话</p>
                  <p className="text-sm text-foreground-200">400-888-9191</p>
                </div>
                <div>
                  <p className="text-foreground-400 text-xs mb-1">邮箱</p>
                  <p className="text-sm text-foreground-200">contact@91heiliaochigua.com</p>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-6">
                快速导航
              </h4>
              <div className="grid grid-cols-2 gap-3">
                <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">首页</Link>
                <Link to="/category/wanghong-tafang" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">网红塌房</Link>
                <Link to="/category/zhubo-bagua" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">主播八卦</Link>
                <Link to="/category/mingxing-heiliao" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">明星黑料</Link>
                <Link to="/category/shehui-redian" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">社会热点</Link>
                <Link to="/category/dujia-baoliao" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">独家爆料</Link>
                <Link to="/category/chigua-shipin" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">吃瓜视频</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">关于我们</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 91黑料吃瓜网 版权所有
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">关于我们</Link>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">用户协议</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}